import { MooringPointType, FairleadType } from '@/domain/type/calculationItem.type.ts'

export const calculateLineLength = (
  mooringPoint: MooringPointType | null,
  winch: object | null,
  fairlead: FairleadType
) => {
  if (!mooringPoint || !winch) {
    return null
  }
  return Math.sqrt(
    Math.pow(mooringPoint.x - fairlead.x, 2) +
      Math.pow(mooringPoint.y - fairlead.y, 2) +
      Math.pow(mooringPoint.z - fairlead.calculated_z, 2)
  )
}
